module.exports = __webpack_public_path__ + "static/media/hero-img.007d16f6.png";